// Page Elements
const filterToggle = document.querySelector('.filter-toggle');
const newsFilterItems = Array.from(document.querySelectorAll('.filter-button'));
const filterContainer = document.querySelector('.filter');
const articles = Array.from(document.querySelectorAll('.ac'));

// Show and hide the filters
filterToggle.onclick = () => filterContainer.classList.toggle('visible');

// Filter the categories
newsFilterItems.forEach((filterItem) => {
  filterItem.onclick = () => filterCategories(filterItem);
});

const filterCategories = function (target) {
  const targetSection = target.getAttribute('data-category');
  newsFilterItems.forEach((filterItem) => {
    filterItem.classList.remove('active');
  });
  target.classList.add('active');
  document.querySelector('.articles').setAttribute('data-filtered', targetSection);
};

// Article Selector
// articles.forEach((article) => {
//   article.onclick = () => articleFocus(article);
// });

const articleFocus = function (article) {
  const url = article.getAttribute('data-url');
  const newArticle = fetch('' + url + '?view=ajax')
    .then((response) => response.json())
    .then((response) => {
      console.log(response);
      document.getElementById('article-content').classList.toggle('hide');
      document.querySelector('#feat-title').innerHTML = response.title;
      document.querySelector('#feat-content').innerHTML = response.body_html;
      document.querySelector('#feat-tag').innerHTML = response.tags;
      // var date = new Date(response.published_at);
      // document.querySelector('#feat-date').innerHTML = response.published_at;
      document.getElementById('feat-image').src = response.image.src;
      return response;
    });

  const revealArticle = async () => {
    const article = await newArticle;
    document.getElementById('article-content').classList.toggle('hide');
    if (window.innerWidth < 1024) {
      document.getElementById('featured').classList.toggle('active');
    }
  };

  revealArticle();
};

document.getElementById('article-close').onclick = () =>
  document.querySelector('#featured').classList.toggle('active');
